export default __webpack_public_path__ + "static/media/logo2.fdc9855c.png";